module.exports = __webpack_public_path__ + "static/media/react-articles.92bc5556.PNG";